import React from 'react';
import Select from 'react-select';

//redux-form expects onblur to return a value.
//wrap react-select and modify onblur
export default function select(props) {

    const {onBlur, options, value_field='id', label_field='name', ...restprops} = props;

    const t_options = options.map(obj => ({value: obj[value_field], label: obj[label_field]}));

    return <Select onBlur={() => onBlur && onBlur(props.value)} options={t_options} {...restprops}/>;
}



// WEBPACK FOOTER //
// ./src/js/components/form/select.jsx